import { SorterResult, TablePaginationConfig } from 'antd/es/table/interface'
import { useState } from 'react'

export const toSort = (sorter) => {
    return sorter.sort && sorter.direction ? [sorter.sort, sorter.direction].join(',') : undefined
}

export const useSorter = (pagination, loadData) => {

    const [sorter, setSorter] = useState<any>({
        sort: 'modified',
        direction: 'desc'
    })

    const handleTableChange = (p: TablePaginationConfig, f, s: SorterResult<any>) => {

        if (pagination.current != p.current) {
            loadData(p.current as number)
            return
        }

        setSorter(s.column ? { sort: s.columnKey, direction: s.order == 'ascend' ? 'asc' : 'desc' } : {})
    }

    return { sorter, handleTableChange }
}


// WEBPACK FOOTER //
// ./src/util/useSorter.ts